// Generated by Melange

import * as Buhta_core__Grpc from "../../../../packages/core/lib/Grpc.js";
import * as Buhta_taxapis__Buhta_tax_control_v1_period from "../../../../proto/taxapis/gen/buhta_tax_control_v1_period.js";
import * as Buhta_taxapis__Buhta_tax_payment_v1alpha1_payroll_tax_service from "../../../../proto/taxapis/gen/buhta_tax_payment_v1alpha1_payroll_tax_service.js";
import * as Curry from "melange.js/curry.js";

const make = Buhta_taxapis__Buhta_tax_control_v1_period.Buhta.Tax.Control.V1.Period.make;

const Period = {
  make: make
};

const make$1 = Buhta_taxapis__Buhta_tax_payment_v1alpha1_payroll_tax_service.Buhta.Tax.Payment.V1alpha1.CalculatePayrollResponse.Employee.make;

const Employee = {
  make: make$1
};

const make$2 = Buhta_taxapis__Buhta_tax_payment_v1alpha1_payroll_tax_service.Buhta.Tax.Payment.V1alpha1.CalculatePayrollResponse.PersonInfo.make;

const EmployeeInfo = {
  make: make$2
};

const make$3 = Buhta_taxapis__Buhta_tax_payment_v1alpha1_payroll_tax_service.Buhta.Tax.Payment.V1alpha1.Earning.make;

const Earning = {
  make: make$3
};

const TaxCategory = {};

function calculate(tenant, reportBlanksOpt, period, param) {
  const reportBlanks = reportBlanksOpt !== undefined ? reportBlanksOpt : false;
  return Buhta_core__Grpc.makeRpc(undefined, Curry._3(Buhta_taxapis__Buhta_tax_payment_v1alpha1_payroll_tax_service.Buhta.Tax.Payment.V1alpha1.CalculatePayrollRequest.make, period, reportBlanks, undefined), Buhta_taxapis__Buhta_tax_payment_v1alpha1_payroll_tax_service.Buhta.Tax.Payment.V1alpha1.PayrollTaxService.calculatePayroll, undefined, undefined, tenant, "/tax" + Buhta_taxapis__Buhta_tax_payment_v1alpha1_payroll_tax_service.Buhta.Tax.Payment.V1alpha1.PayrollTaxService.CalculatePayroll.name, undefined, undefined);
}

const PayrollTaxService = {
  calculate: calculate
};

export {
  Period,
  Employee,
  EmployeeInfo,
  Earning,
  TaxCategory,
  PayrollTaxService,
}
/* Buhta_core__Grpc Not a pure module */
